import React from 'react';
import styles from './BodySectionContainer.module.scss';
import { SectionTitle } from 'components';

const BodySectionContainer = ({
  title, children = null, className = ''
}) => {
  const [expanded, setExpandedState] = React.useState(true);
  const onTitleClick = children
    ? () => setExpandedState(!expanded)
    : null;

  return (
    <div className={`${styles.container} ${className}`}>
    
      <SectionTitle
        text={title}
        onClick={onTitleClick}
        expanded={expanded}
      />
      {expanded && children}
    </div>
  );
};

export default BodySectionContainer;
